"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _BestDropdown = _interopRequireDefault(require("../../elements/form/elements/BestDropdown"));
var _PrimaryButton = _interopRequireDefault(require("../../elements/form/buttons/PrimaryButton"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var LogLevelDropdown = (0, _styledComponents["default"])(_BestDropdown["default"]).withConfig({
  displayName: "LogLevelChanger__LogLevelDropdown",
  componentId: "sc-7o6oqb-0"
})(["&&&{width:9.375rem;}"]);
var LoggerDropdown = (0, _styledComponents["default"])(_BestDropdown["default"]).withConfig({
  displayName: "LogLevelChanger__LoggerDropdown",
  componentId: "sc-7o6oqb-1"
})(["&&&{width:21.675rem;}"]);
var dispatcherConstants = {
  SET_LOG_LEVELS: "SET_LOG_LEVELS",
  SET_LOGGERS: "SET_LOGGERS",
  SET_LOG_LEVEL: "SET_LOG_LEVEL",
  SET_LOGGER: "SET_LOGGER",
  SET_IS_DISABLED: "SET_IS_DISABLED"
};
var initialState = {
  logLevels: [],
  loggers: [],
  logLevel: {
    label: "",
    value: ""
  },
  logger: {
    label: "",
    value: ""
  },
  isDisabled: true
};
var reducer = function reducer(state, action) {
  switch (action.type) {
    case dispatcherConstants.SET_LOG_LEVELS:
      return _objectSpread({}, state, {
        logLevels: action.logLevels
      });
    case dispatcherConstants.SET_LOGGERS:
      return _objectSpread({}, state, {
        loggers: action.loggers
      });
    case dispatcherConstants.SET_LOG_LEVEL:
      return _objectSpread({}, state, {
        logLevel: action.logLevel
      });
    case dispatcherConstants.SET_LOGGER:
      return _objectSpread({}, state, {
        logger: action.logger
      });
    case dispatcherConstants.SET_IS_DISABLED:
      return _objectSpread({}, state, {
        isDisabled: action.isDisabled
      });
    default:
      return new Error();
  }
};
var LogLevelChanger = function LogLevelChanger(_ref) {
  var url = _ref.url;
  var _useReducer = (0, _react.useReducer)(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  (0, _react.useEffect)(function () {
    _axios["default"].get(url).then(function (response) {
      dispatch({
        type: dispatcherConstants.SET_LOG_LEVELS,
        logLevels: response.data.levels.map(function (level) {
          return {
            label: level,
            value: level
          };
        })
      });
      dispatch({
        type: dispatcherConstants.SET_LOGGERS,
        loggers: Object.keys(response.data.loggers).map(function (loggerName) {
          return {
            label: loggerName,
            value: loggerName
          };
        })
      });
    });
  }, []);
  (0, _react.useEffect)(function () {
    dispatch({
      type: dispatcherConstants.SET_IS_DISABLED,
      isDisabled: !state.logLevel.value || !state.logger.value
    });
  }, [state.logLevel.value, state.logger.value]);
  var updateLogLevel = function updateLogLevel() {
    var body = {
      configuredLevel: state.logLevel.value
    };
    _axios["default"].post(url.concat("/", state.logger.value), body).then(function (response) {
      console.log("SUCCESS", response);
    })["catch"](function (response) {
      console.log("ERROR", response);
    });
  };
  return _react["default"].createElement("div", {
    className: "d-flex justify-content-around align-items-end"
  }, _react["default"].createElement(LogLevelDropdown, {
    onChange: function onChange(value) {
      return dispatch({
        type: dispatcherConstants.SET_LOG_LEVEL,
        logLevel: value
      });
    },
    value: state.logLevel,
    id: "logLevels",
    title: "Log Level",
    options: state.logLevels
  }), _react["default"].createElement(LoggerDropdown, {
    onChange: function onChange(value) {
      return dispatch({
        type: dispatcherConstants.SET_LOGGER,
        logger: value
      });
    },
    value: state.logger,
    id: "loggers",
    title: "Logger",
    options: state.loggers
  }), _react["default"].createElement(_PrimaryButton["default"], {
    onClick: updateLogLevel,
    disabled: state.isDisabled
  }, "Change level"));
};
LogLevelChanger.propTypes = {
  url: _propTypes["default"].string.isRequired
};
var _default = LogLevelChanger;
exports["default"] = _default;